var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#FFF5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1626 12H14.8374C14.3749 12 14 12.3749 14 12.8374C14 15.5027 15.0588 18.0588 16.9434 19.9434L18.1626 21.1626C18.2836 21.2836 18.3442 21.3442 18.3875 21.4023C18.6519 21.7569 18.6519 22.2431 18.3875 22.5977C18.3442 22.6558 18.2836 22.7164 18.1626 22.8374L16.9434 24.0566C15.0588 25.9412 14 28.4973 14 31.1626C14 31.6251 14.3749 32 14.8374 32H27.1626C27.6251 32 28 31.6251 28 31.1626C28 28.4973 26.9412 25.9412 25.0566 24.0566L23.8374 22.8374C23.7164 22.7164 23.6558 22.6558 23.6125 22.5977C23.3481 22.2431 23.3481 21.7569 23.6125 21.4023C23.6558 21.3442 23.7164 21.2836 23.8374 21.1626L25.0566 19.9434C26.9412 18.0588 28 15.5027 28 12.8374C28 12.3749 27.6251 12 27.1626 12Z",
    stroke: "#FDCC0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.d4a103d58fa81acb453a0c3b2dd53555.svg";
export { ForwardRef as ReactComponent };